<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapActions, mapMutations, mapState } from 'vuex'

  export default {
    name: 'app',
    data () {
      return {}
    },
    components: {},
    created () {
      axios.interceptors.response.use(function (response) {
        return response
      }, (error) => {
        if (axios.isCancel(error)) {
          return Promise.reject(error)
        } else {
          this.showToast(error.response, error.config)
          return Promise.reject(error)
        }
      })
      window.addEventListener('storage', () => {
        axios.defaults.headers.common.Authorization = window.localStorage.getItem('token')
      })
    },
    computed: {
      ...mapState(
        {
          status: state => state.authorization.status,
          token: state => state.authorization.token
        }
      )
    },
    methods: {
      ...mapActions([]),
      ...mapMutations({}),
      showToast (error) {
        let toastTitle = null
        if (error.status === 400) {
          if (error.data.detail) {
            toastTitle = error.data.detail + ' (ErrorCode: 400)'
          } else {
            toastTitle = 'Отправлены некорректные данные'
          }
        } else if (error.status === 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          // delete axios.defaults.headers.common.Authorization
          // this.$router.push({ name: 'Login' })
        } else if (error.status === 403) {
          toastTitle = 'Отказано в доступе'
        } else if (error.status === 404) {
          toastTitle = 'Запрашиваемый ресурс не найден'
        } else if (error.status === 409) {
          if (error.data.detail) {
            toastTitle = error.data.detail + ' (ErrorCode: 409)'
          } else {
            toastTitle = 'Сервис временно недоступен (ErrorCode: 409)'
          }
        } else if (error.status === 500) {
          toastTitle = 'Сервис временно недоступен(500)'
        } else if (error.status === 502) {
          toastTitle = 'Сервис временно недоступен(502)'
        } else if (error.status === 503) {
          toastTitle = 'Сервис временно недоступен(503)'
        } else if (error.status === 504) {
          toastTitle = 'Сервис временно недоступен(504)'
        }
        this.$bvToast.toast(toastTitle, {
          title: 'Что-то пошло не так',
          variant: 'danger',
          name: 'b-toaster-top-center'
        })
      }
    }
  }
</script>

<style lang="scss">
  @import 'assets/custom-bootstrap.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
  @import '../node_modules/bootstrap-vue/src/index.scss';
  @media screen and (min-width: 320px) and (max-width: 1023px) {
    #app {
      height: 100vh !important;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
</style>
